/* ==========================================================================
   Dida - Selleasy iskačući prozor: prevod natpisa i označavanje dugmadi

   ZAŠTO JS, A NE CSS:
   Prvi pokušaj je menjao tekst preko ::after uz font-size: 0. Klase te
   aplikacije ponavljaju se na više ugnježdenih elemenata (host > cont >
   button), pa se isti natpis ispisivao dva ili tri puta jedan preko drugoga.
   Ovde se tekst menja tačno jednom, na elementu koji ga stvarno sadrži,
   i dodaje se vlastita klasa da CSS ima jednoznačnu metu.

   ⚠️ Natpis "Dodaj u korpu" mora biti isti kao dugme u temi
   (locales/hr.json -> products.product.add_to_cart), jer uputstvo na
   naslovnici imenuje baš to dugme.

   Ne dira ništa izvan .lb-popup-cont.
   ========================================================================== */

(function () {
  'use strict';

  var PREVODI = [
    ['Add items to cart', 'Dodaj u korpu'],
    ['Add item to cart', 'Dodaj u korpu'],
    ['Dodaj u košaricu', 'Dodaj u korpu'],
    ['Skip this offer', 'Ne, hvala'],
    ['No thanks', 'Ne, hvala'],
    ['Often bought together', 'Uzmi još i uštedi!'],
    ['Frequently bought together', 'Uzmi još i uštedi!'],
    ['Često kupljeno zajedno', 'Uzmi još i uštedi!'],
    ['Take more and save', 'Uzmi još i uštedi!'],
    ['Select a product', 'Izaberite proizvod'],
    ['Select product', 'Izaberite proizvod'],
  ];

  function prevediJednom(koren) {
    // Samo tekstualni čvorovi: tako se menja tačno jedan element,
    // onaj koji tekst doista sadrži, bez diranja roditelja.
    var hodac = document.createTreeWalker(koren, NodeFilter.SHOW_TEXT, null);
    var cvor;
    while ((cvor = hodac.nextNode())) {
      var t = cvor.nodeValue.trim();
      if (!t) continue;
      for (var i = 0; i < PREVODI.length; i++) {
        if (t.toLowerCase() === PREVODI[i][0].toLowerCase()) {
          cvor.nodeValue = cvor.nodeValue.replace(t, PREVODI[i][1]);
          break;
        }
      }
    }
  }

  function oznaciDugmad(koren) {
    var dugmad = koren.querySelectorAll('button, [role="button"]');
    for (var i = 0; i < dugmad.length; i++) {
      var g = dugmad[i];
      // preskoči omotače: obeležava se samo element koji ima vlastiti tekst
      if (!g.textContent || !g.textContent.trim()) continue;
      if (g.querySelector('button')) continue;

      var t = g.textContent.trim().toLowerCase();
      if (t.indexOf('ne, hvala') === 0 || t.indexOf('skip') === 0) {
        g.classList.add('dida-up-sporedni');
      } else if (
        t.indexOf('dodaj u korpu') === 0 ||
        t.indexOf('dodaj u košaricu') === 0 ||
        t.indexOf('add item') === 0 ||
        t.indexOf('izaberite proizvod') === 0 ||
        t.indexOf('select') === 0
      ) {
        g.classList.add('dida-up-glavni');
      }
    }
  }

  function obradi() {
    var p = document.querySelector('.lb-popup-cont');
    if (!p) return;
    prevediJednom(p);
    oznaciDugmad(p);
  }

  // Namerno setTimeout, a NE requestAnimationFrame: rAF se u kartici koja
  // nije u prvom planu ne izvršava, pa se popup ne bi preveo dok korisnik
  // ne vrati prozor. setTimeout radi uvek.
  var zakazano = false;
  var promatrac = new MutationObserver(function () {
    if (zakazano) return;
    zakazano = true;
    setTimeout(function () {
      zakazano = false;
      obradi();
    }, 0);
  });

  function pokreni() {
    promatrac.observe(document.body, { childList: true, subtree: true });
    obradi();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pokreni);
  } else {
    pokreni();
  }
})();
